import { Injectable } from "@angular/core";
import { BaseCrudService } from "src/app/services/apps/generic/base.service";
import {
  IPullSheetCreateDTO,
  IPullSheetGetDTO,
  IPullSheetUpdateDTO,
} from "./models";
import { environment } from "src/environments/environment";
import { Observable, map } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PullSheetService extends BaseCrudService<
  IPullSheetGetDTO,
  IPullSheetCreateDTO,
  IPullSheetUpdateDTO,
  string
> {
  constructor() {
    super(environment.endpoints.pull_sheet.pull_sheets);
  }

  override get(
    params?: Record<string, any>,
    id?: string
  ): Observable<IPullSheetGetDTO[]> {
    return super
      .get(params, id)
      .pipe(
        map((items) =>
          items
            .slice()
            .sort(
              (a, b) =>
                new Date(b.generatedOn).getTime() -
                new Date(a.generatedOn).getTime()
            )
        )
      );
  }

  downloadCsv(body: {
    pullSheetId: string;
    pullDate: string;
  }): Observable<any> {
    return this.http.post(
      environment.baseApiUrl + environment.endpoints.orders.download_csv,
      body,
      {
        responseType: "blob",
        observe: "response",
      }
    );
  }
}
